import React from 'react';
const GroupContext = /*#__PURE__*/React.createContext(null);
export default GroupContext;